import { Routes, Route, useLocation, Navigate} from "react-router-dom";
import Home from "./pages/Home";
import SeaBreeze from "./pages/SeaBreeze";
import UserBookingsPage from "./pages/UserBookingsPage";
import Success from "./pages/Success";
import Info from "./pages/Info";
import LoginComponent from "./pages/LoginComponent";
import RegistrationPage from "./pages/RegistrationPage";
import DinerthCottage from "./pages/DinerthCottage";
import { auth } from "./firebase-config";

const App = () => {
  const user = auth.currentUser;

  return (
    <Routes>
      <Route
        index
        path="/"
        element={<Home />}
      />
      <Route
        index
        path="/sea-breeze"
        element={<SeaBreeze/>}
        />
      <Route
        index
        path="/dinerth-cottage"
        element={<DinerthCottage />}
      />
      <Route
        path="/login"
        element={user ? <Navigate to="/" /> :<LoginComponent />}
      />
      <Route
        path="/register"
        element={user ? <Navigate to="/" /> : <RegistrationPage />}
      />
      <Route
        path="/info"
        element={<Info />}
      />
      <Route
        path="/user-bookings"
        element={user ? <UserBookingsPage /> : <Navigate to="/" />}
      />
      <Route
        path="/success"
        element={user ? <Success />: <Navigate to="/" />}
      />
    </Routes>
  );
};

export default App;
